const variants = {
  bestseller: 'bg-maroon text-light',
  new:        'bg-wine   text-light',
  rare:       'border border-maroon/25 text-maroon/70',
  staff:      'bg-sand   text-maroon',
  'dark-rare':'border border-sand/25 text-sand/60',
};

export default function Badge({ type, label }) {
  return (
    <span className={`text-[9px] font-medium tracking-[0.15em] uppercase px-2.5 py-1 ${variants[type] || variants.rare}`}>
      {label}
    </span>
  );
}
